<template>
  <div>
    <b-form-group label-align="right" :label="$t('Credit')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input type="number" v-model="newAccount.credit"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('VAT')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input type="number" v-model="newAccount.vat_rate"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('External ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input v-model="newAccount.external_id"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Sale tax rate')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input v-model="newAccount.sale_tax_rate"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Internet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-select :options="internet" v-model="newAccount.int_status"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Block')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-select :options="blockType" v-model="newAccount.is_blocked"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Auto enable internet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-checkbox v-model="newAccount.auto_enable_inet"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Unlimited mode')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-checkbox v-model="newAccount.unlimited"/>
    </b-form-group>

    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addAccount">{{ $t('Save') }}</b-button>
      </b-col>
      <b-col sm="1.5">
        <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideAddAccount">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'

export default {
  props: {
    currentRow: null
  },
  data () {
    return {
      internet: [{'text': this.$i18n.t('On'), 'value': 1}, {'text': this.$i18n.t('Off'), 'value': 0}],
      blockType: [{'text': this.$i18n.t('Active'), 'value': false}, {'text': this.$i18n.t('Admin block'), 'value': true}],
      newAccount: {
        'user_id': 0,
        'is_basic': false,
        'is_blocked': false,
        'balance': 0,
        'credit': 0,
        'vat_rate': 0,
        'sale_tax_rate': 0,
        'int_status': 1,
        'unlimited': false,
        'auto_enable_inet': false,
        'external_id': ''
      }
    }
  },
  methods: {
    hideAddAccount () {
      this.$emit('hideAddAccount')
    },
    addAccount () {
      this.newAccount.user_id = this.currentRow.user_id
      this.newAccount.credit = Number(this.newAccount.credit)
      this.newAccount.sale_tax_rate = Number(this.newAccount.sale_tax_rate)
      this.newAccount.vat_rate = Number(this.newAccount.vat_rate)
      axiosInstance.post(this.$store.getters.API_USERS_ACCOUNTS, this.newAccount).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$emit('refreshTable')
          this.$root.$emit('makeToasts')
          this.hideAddAccount()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/accounts/formAdd.vue